import type { DeepPartial, ChartOptions } from 'lightweight-charts'

export const lightThemeVars = {
  '--tv-bg-primary': '#ffffff',
  '--tv-bg-secondary': '#f0f3fa',
  '--tv-bg-tertiary': '#e0e3eb',
  '--tv-border': '#e0e3eb',
  '--tv-border-light': '#d1d4dc',
  '--tv-text-primary': '#131722',
  '--tv-text-secondary': '#4c525e',
  '--tv-text-muted': '#787b86',
  '--tv-blue': '#2962ff',
  '--tv-green': '#26a69a',
  '--tv-red': '#ef5350',
} as const

export const lightChartTheme: DeepPartial<ChartOptions> = {
  layout: {
    background: { color: '#ffffff' },
    textColor: '#131722',
    fontFamily: 'Inter, system-ui, sans-serif',
    fontSize: 11,
  },
  grid: {
    vertLines: { visible: false },
    horzLines: { color: '#f0f3fa', style: 0 },
  },
  crosshair: {
    vertLine: {
      color: '#787b86',
      width: 1,
      style: 3,
      labelBackgroundColor: '#e0e3eb',
    },
    horzLine: {
      color: '#787b86',
      width: 1,
      style: 3,
      labelBackgroundColor: '#e0e3eb',
    },
  },
  rightPriceScale: {
    borderColor: '#e0e3eb',
    textColor: '#4c525e',
  },
  timeScale: {
    borderColor: '#e0e3eb',
    timeVisible: true,
    secondsVisible: false,
    rightOffset: 20,
    fixRightEdge: false,
    fixLeftEdge: false,
  },
  watermark: { visible: false },
}

export const lightCandleColors = {
  upColor: '#26a69a',
  downColor: '#ef5350',
  borderUpColor: '#26a69a',
  borderDownColor: '#ef5350',
  wickUpColor: '#26a69a',
  wickDownColor: '#ef5350',
}
